const LoaderLogoGibobs = () => {
	return (
		<>
			<div className="infinity">
				<div>
					<span></span>
				</div>
				<div>
					<span></span>
				</div>
				<div>
					<span></span>
				</div>
			</div>
		</>
	);
};
export default LoaderLogoGibobs;
